import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const WhatCanIOfferSection = () => {
  return (
    <Container fluid as="section">
      <Container className="what-can-i-offer-section" data-aos="fade-right">
        <Row className="container-block">
          <h2>What Can I Offer?</h2>
          <Col sm="12" md="12" lg="4">
            <h3>Professionalism</h3>
            <div className="underline"></div>
            <p>
              The quality of my work is important to me, I never miss a gig,
              rehearsal or recording and pride myself on my punctuation.
            </p>
          </Col>
          <Col sm="12" md="12" lg="4">
            <h3>Dedication</h3>
            <div className="underline"></div>
            <p>
              Any project I undertake I give 100% to, I am dedicated to seeing a
              project through to the end and helping it come to life.
            </p>
          </Col>
          <Col sm="12" md="12" lg="4">
            <h3>Flexibility</h3>
            <div className="underline"></div>
            <p>
              No matter what type of music I play I give it my all, versatility
              is a big part of my style and something which I have perfected.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
